import React, { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { PwaInstaller } from '../../components/widget';
import { useAlita } from 'redux-alita';
import umbrella from 'umbrella-storage';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useUpdateEffect } from 'ahooks';
import authService from '../../service/auth';
import history from '../../utils/history';
import { message } from 'antd';

const FormItem = Form.Item;

const Login: React.FC = (props) => {
    const clearLegacyOverlays = () => {
        Modal.destroyAll();
        const staleMaskSelectors = [
            '.ant-modal-root',
            '.ant-modal-mask',
            '.ant-modal-wrap',
            '.ant-drawer-mask',
            '.ant-drawer-wrap',
        ];
        staleMaskSelectors.forEach((selector) => {
            document.querySelectorAll(selector).forEach((node) => {
                node.parentNode?.removeChild(node);
            });
        });
        document.body.classList.remove('ant-scrolling-effect');
        if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = '';
        }
        if (document.body.style.width) {
            document.body.style.width = '';
        }
    };

    const onFinish = async (values: any) => {
        clearLegacyOverlays();
        localStorage.setItem('@primary-color', '#BB2649'); //设置默认背景色
        const res = await authService.login(values.username, values.password);
        if (res && res.data.success) {
            const permissionResponse = await authService.getCurrentPermissions();
            const permissionData =
                permissionResponse && permissionResponse.data.success
                    ? permissionResponse.data.data
                    : {};
            setAlita('auth', {
                username: res.data.data.userName,
                account: res.data.data.account,
                ...permissionData,
            });
            history.push('/app/dashboard/index');
            setTimeout(() => {
                window.location.reload();
            }, 200); //确保 Cookie 写入成功
        } else if (res) {
            message.error(res.data.message);
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        message.error('登录失败');
    };

    const [auth, setAlita] = useAlita({ auth: {} }, { light: true });
    useEffect(() => {
        clearLegacyOverlays();
        setAlita('auth', null);
    }, [setAlita]);

    useUpdateEffect(() => {
        if (auth) {
            // 判断是否登陆
            umbrella.setLocalStorage('user', auth);
            history.push('/app/dashboard/index');
        }
    }, [history, auth]);

    return (
        <div className="login">
            <div className="login-form">
                <div className="login-logo">
                    <span> 心睿咨询CRM系统</span>
                    <PwaInstaller />
                </div>
                <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    style={{ maxWidth: '300px' }}
                >
                    <FormItem
                        name="username"
                        rules={[{ required: true, message: '请输入用户名!' }]}
                    >
                        <Input prefix={<UserOutlined size={13} />} placeholder="请输入管理员账号" />
                    </FormItem>
                    <FormItem name="password" rules={[{ required: true, message: '请输入密码!' }]}>
                        <Input
                            autoComplete="off"
                            prefix={<LockOutlined size={13} />}
                            type="password"
                            placeholder="请输入管理员密码"
                        />
                    </FormItem>
                    <FormItem>
                        {/* <span className="login-form-forgot" style={{ float: 'right' }}>
                            忘记密码
                        </span> */}
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            style={{ width: '100%' }}
                        >
                            登录
                        </Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    );
};

export default Login;
